import {configureStore} from "@reduxjs/toolkit";
import {apiSlice} from "./api/baseApiSlice";
import {baseLanggraphApiSlice} from "./api/langgraph/baseApiSliceLanggraph";
import authReducer from 'redux/features/authSlice'
import optionsReducer from 'redux/features/optionsSlice'
import negotiationUsersReducer from 'redux/features/negotiationUsersSlice'
import userReducer from 'redux/features/userSlice'
import overlayReducer from 'redux/features/overlaySlice'
import countriesReducer from 'redux/features/countriesSlice'

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        [baseLanggraphApiSlice.reducerPath]: baseLanggraphApiSlice.reducer,
        auth: authReducer,

        userProfiles: negotiationUsersReducer,
        options: optionsReducer,
        user: userReducer,
        overlay: overlayReducer,
        countries: countriesReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        // serializableCheck: {ignoredPaths: ['api.queries.getBelatedReportsDownload',]}
        //serializableCheck: false
    })
        .concat(apiSlice.middleware).concat(baseLanggraphApiSlice.middleware),
    devTools: process.env.NODE_ENV !== 'production',
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {api: CombinedState, auth: AuthSliceState}
export type AppDispatch = typeof store.dispatch